import commonHelper from '@/app/utility/common.helper.utility';
import addMasterRule from './addMasterRule';
import { ModelSelect } from 'vue-search-select';
export default {
  name: 'workFlowMasterRule',
  components: { addMasterRule, ModelSelect },
  props: { showMasterRuleModal: Boolean },
  watch: {
    currentPage: function() {
      this.getMasterRuleList();
    },
    perPage: function() {
      this.currentPage = 1;
      this.getMasterRuleList();
    }
  },
  data() {
    return {
      setTimeVsetCode: null,
      showValueSetModal: false,
      active: true,
      timeOut: null,
      payload: {},
      showAddGroup: false,
      unsubscribe: null,
      ruleName: null,
      loader: false,
      pageOptions: commonHelper.getPageOption(),
      perPage: commonHelper.perPageRecord,
      valueSetName: null,
      currentPage: 1,
      totalRows: null,
      selectedLegalEntity: {
        value: null,
        text: null
      },
      ruleList: [],
      ruleFeilds: [
        {
          key: 'rule_name'
        },
        {
          key: 'le_name',
          label: 'Legal Entity'
        },
        {
          key: 'active'
        },
        {
          key: 'version'
        }
      ]
    };
  },
  mounted() {
    this.getMasterRuleList();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'add') {
          this.showAddGroup = true;
        }
        if (actionName === 'download') {
          this.loader = true;
          /**
           * @param(payload, 'action name', 'file name')
           */
          const downloadpayload = { ...this.payload };
          downloadpayload._limit = this.totalRows;
          this.downloadExcel.downloadData(
            downloadpayload,
            'workflow/getMasterRuleList',
            'workflow-masterRule',
            () => (this.loader = false)
          );
        }
      }
    });
  },
  methods: {
    getMasterRuleList() {
      this.loader = true;
      this.payload = {
        _page: this.currentPage - 1,
        _limit: this.perPage,
        rule_name: this.ruleName,
        active: this.active,
        le_id: this.selectedLegalEntity.value
      };
      this.$store
        .dispatch('workflow/getMasterRuleList', this.payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.ruleList = response.data.data.page;
            this.totalRows = response.data.data.total_elements;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    clear() {
      this.ruleName = null;
      this.active = false;
      this.selectedLegalEntity = {
        value: null,
        text: null
      };
      this.getMasterRuleList();
    },
    hideGroupModal() {
      this.showAddGroup = false;
    },
    rowSelected(item) {
      if (this.showMasterRuleModal) {
        this.$emit('selectedRule', item);
      } else {
        this.showAddGroup = true;
        this.timeOut = setTimeout(() => {
          this.eventBus.$emit('groupDetail', item);
        }, 0);
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    openValueSetModal(vsetCode) {
      this.showValueSetModal = true;
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      this.selectedLegalEntity.value = item.org_id;
      this.selectedLegalEntity.text = item.org_name;
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode) {
      if (vsetCode === 'LEGAL_ENTITY_LIST') {
        this.selectedLegalEntity.value = null;
        this.selectedLegalEntity.text = null;
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
    clearTimeout(this.setTimeVsetCode);
    this.unsubscribe();
  }
};
